"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var serviceAsync=require("@gjensidige/service-async"),serviceQuerystring=require("@gjensidige/service-querystring"),__assign=function(){return(__assign=Object.assign||function(e){for(var r,n=1,t=arguments.length;n<t;n++)for(var o in r=arguments[n])Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o]);return e}).apply(this,arguments)};function __rest(e,r){var n={};for(o in e)Object.prototype.hasOwnProperty.call(e,o)&&r.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols)for(var t=0,o=Object.getOwnPropertySymbols(e);t<o.length;t++)r.indexOf(o[t])<0&&Object.prototype.propertyIsEnumerable.call(e,o[t])&&(n[o[t]]=e[o[t]]);return n}function __awaiter(e,a,s,u){return new(s=s||Promise)(function(n,r){function t(e){try{i(u.next(e))}catch(e){r(e)}}function o(e){try{i(u.throw(e))}catch(e){r(e)}}function i(e){var r;e.done?n(e.value):((r=e.value)instanceof s?r:new s(function(e){e(r)})).then(t,o)}i((u=u.apply(e,a||[])).next())})}function __generator(n,t){var o,i,a,s={label:0,sent:function(){if(1&a[0])throw a[1];return a[1]},trys:[],ops:[]},e={next:r(0),throw:r(1),return:r(2)};return"function"==typeof Symbol&&(e[Symbol.iterator]=function(){return this}),e;function r(r){return function(e){return function(r){if(o)throw new TypeError("Generator is already executing.");for(;s;)try{if(o=1,i&&(a=2&r[0]?i.return:r[0]?i.throw||((a=i.return)&&a.call(i),0):i.next)&&!(a=a.call(i,r[1])).done)return a;switch(i=0,(r=a?[2&r[0],a.value]:r)[0]){case 0:case 1:a=r;break;case 4:return s.label++,{value:r[1],done:!1};case 5:s.label++,i=r[1],r=[0];continue;case 7:r=s.ops.pop(),s.trys.pop();continue;default:if(!(a=0<(a=s.trys).length&&a[a.length-1])&&(6===r[0]||2===r[0])){s=0;continue}if(3===r[0]&&(!a||r[1]>a[0]&&r[1]<a[3])){s.label=r[1];break}if(6===r[0]&&s.label<a[1]){s.label=a[1],a=r;break}if(a&&s.label<a[2]){s.label=a[2],s.ops.push(r);break}a[2]&&s.ops.pop(),s.trys.pop();continue}r=t.call(n,s)}catch(e){r=[6,e],i=0}finally{o=a=0}if(5&r[0])throw r[1];return{value:r[0]?r[1]:void 0,done:!0}}([r,e])}}}function __read(e,r){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var t,o,i=n.call(e),a=[];try{for(;(void 0===r||0<r--)&&!(t=i.next()).done;)a.push(t.value)}catch(e){o={error:e}}finally{try{t&&!t.done&&(n=i.return)&&n.call(i)}finally{if(o)throw o.error}}return a}function __spreadArray(e,r,n){if(n||2===arguments.length)for(var t,o=0,i=r.length;o<i;o++)!t&&o in r||((t=t||Array.prototype.slice.call(r,0,o))[o]=r[o]);return e.concat(t||Array.prototype.slice.call(r))}var commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},stacktrace={exports:{}},errorStackParser={exports:{}},stackframe={exports:{}};stackframe.exports=function(){function n(e){return!isNaN(parseFloat(e))&&isFinite(e)}function t(e){return e.charAt(0).toUpperCase()+e.substring(1)}function e(e){return function(){return this[e]}}var r=["isConstructor","isEval","isNative","isToplevel"],o=["columnNumber","lineNumber"],i=["fileName","functionName","source"],a,s,u=r.concat(o,i,["args"],["evalOrigin"]);function p(e){if(!e)return;for(var r=0;r<u.length;r++)if(e[u[r]]!==undefined)this["set"+t(u[r])](e[u[r]])}p.prototype={getArgs:function(){return this.args},setArgs:function(e){if(Object.prototype.toString.call(e)!=="[object Array]")throw new TypeError("Args must be an Array");this.args=e},getEvalOrigin:function(){return this.evalOrigin},setEvalOrigin:function(e){if(e instanceof p)this.evalOrigin=e;else if(e instanceof Object)this.evalOrigin=new p(e);else throw new TypeError("Eval Origin must be an Object or StackFrame")},toString:function(){var e=this.getFileName()||"";var r=this.getLineNumber()||"";var n=this.getColumnNumber()||"";var t=this.getFunctionName()||"";if(this.getIsEval()){if(e)return"[eval] ("+e+":"+r+":"+n+")";return"[eval]:"+r+":"+n}if(t)return t+" ("+e+":"+r+":"+n+")";return e+":"+r+":"+n}},p.fromString=function e(r){var n=r.indexOf("(");var t=r.lastIndexOf(")");var o=r.substring(0,n);var i=r.substring(n+1,t).split(",");var a=r.substring(t+1);if(a.indexOf("@")===0){var s=/@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(a,"");var u=s[1];var c=s[2];var l=s[3]}return new p({functionName:o,args:i||undefined,fileName:u,lineNumber:c||undefined,columnNumber:l||undefined})};for(var c=0;c<r.length;c++){p.prototype["get"+t(r[c])]=e(r[c]);p.prototype["set"+t(r[c])]=function(r){return function(e){this[r]=Boolean(e)}}(r[c])}for(var l=0;l<o.length;l++){p.prototype["get"+t(o[l])]=e(o[l]);p.prototype["set"+t(o[l])]=function(r){return function(e){if(!n(e))throw new TypeError(r+" must be a Number");this[r]=Number(e)}}(o[l])}for(var f=0;f<i.length;f++){p.prototype["get"+t(i[f])]=e(i[f]);p.prototype["set"+t(i[f])]=function(r){return function(e){this[r]=String(e)}}(i[f])}return p}(),errorStackParser.exports=function(u){var t=/(^|@)\S+:\d+/;var o=/^\s*at .*(\S+:\d+|\(native\))/m;var i=/^(eval@)?(\[native code])?$/;return{
/**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
parse:function e(r){if(typeof r.stacktrace!=="undefined"||typeof r["opera#sourceloc"]!=="undefined")return this.parseOpera(r);else if(r.stack&&r.stack.match(o))return this.parseV8OrIE(r);else if(r.stack)return this.parseFFOrSafari(r);else throw new Error("Cannot parse given Error object")},
// Separate line and column numbers from a string of the form: (URI:Line:Column)
extractLocation:function e(r){
// Fail-fast but return locations like "(native)"
if(r.indexOf(":")===-1)return[r];var n=/(.+?)(?::(\d+))?(?::(\d+))?$/;var t=n.exec(r.replace(/[()]/g,""));return[t[1],t[2]||undefined,t[3]||undefined]},parseV8OrIE:function e(r){var n=r.stack.split("\n").filter(function(e){return!!e.match(o)},this);return n.map(function(e){if(e.indexOf("(eval ")>-1)
// Throw away eval information until we implement stacktrace.js/stackframe#8
e=e.replace(/eval code/g,"eval").replace(/(\(eval at [^()]*)|(\),.*$)/g,"");var r=e.replace(/^\s+/,"").replace(/\(eval code/g,"(");
// capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
// case it has spaces in it, as the string is split on \s+ later on
var n=r.match(/ (\((.+):(\d+):(\d+)\)$)/);
// remove the parenthesized location from the line, if it was matched
r=n?r.replace(n[0],""):r;var t=r.split(/\s+/).slice(1);
// if a location was matched, pass it to extractLocation() otherwise pop the last token
var o=this.extractLocation(n?n[1]:t.pop());var i=t.join(" ")||undefined;var a=["eval","<anonymous>"].indexOf(o[0])>-1?undefined:o[0];return new u({functionName:i,fileName:a,lineNumber:o[1],columnNumber:o[2],source:e})},this)},parseFFOrSafari:function e(r){var n=r.stack.split("\n").filter(function(e){return!e.match(i)},this);return n.map(function(e){
// Throw away eval information until we implement stacktrace.js/stackframe#8
if(e.indexOf(" > eval")>-1)e=e.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g,":$1");if(e.indexOf("@")===-1&&e.indexOf(":")===-1)
// Safari eval frames only have function names and nothing else
return new u({functionName:e});else{var r=/((.*".+"[^@]*)?[^@]*)(?:@)/;var n=e.match(r);var t=n&&n[1]?n[1]:undefined;var o=this.extractLocation(e.replace(r,""));return new u({functionName:t,fileName:o[0],lineNumber:o[1],columnNumber:o[2],source:e})}},this)},parseOpera:function e(r){if(!r.stacktrace||r.message.indexOf("\n")>-1&&r.message.split("\n").length>r.stacktrace.split("\n").length)return this.parseOpera9(r);else if(!r.stack)return this.parseOpera10(r);else return this.parseOpera11(r)},parseOpera9:function e(r){var n=/Line (\d+).*script (?:in )?(\S+)/i;var t=r.message.split("\n");var o=[];for(var i=2,a=t.length;i<a;i+=2){var s=n.exec(t[i]);if(s)o.push(new u({fileName:s[2],lineNumber:s[1],source:t[i]}))}return o},parseOpera10:function e(r){var n=/Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;var t=r.stacktrace.split("\n");var o=[];for(var i=0,a=t.length;i<a;i+=2){var s=n.exec(t[i]);if(s)o.push(new u({functionName:s[3]||undefined,fileName:s[2],lineNumber:s[1],source:t[i]}))}return o},
// Opera 10.65+ Error.stack very similar to FF/Safari
parseOpera11:function e(r){var n=r.stack.split("\n").filter(function(e){return!!e.match(t)&&!e.match(/^Error created at/)},this);return n.map(function(e){var r=e.split("@");var n=this.extractLocation(r.pop());var t=r.shift()||"";var o=t.replace(/<anonymous function(: (\w+))?>/,"$2").replace(/\([^)]*\)/g,"")||undefined;var i;if(t.match(/\(([^)]*)\)/))i=t.replace(/^[^(]+\(([^)]*)\)$/,"$1");var a=i===undefined||i==="[arguments not available]"?undefined:i.split(",");return new u({functionName:o,args:a,fileName:n[0],lineNumber:n[1],columnNumber:n[2],source:e})},this)}}}(stackframe.exports);var stackGenerator={exports:{}};!function(){var a;stackGenerator.exports=(a=stackframe.exports,{backtrace:function(e){var r=[],n=10;"object"==typeof e&&"number"==typeof e.maxStackSize&&(n=e.maxStackSize);for(var t=arguments.callee;t&&r.length<n&&t.arguments;){for(
// Allow V8 optimizations
var o=new Array(t.arguments.length),i=0;i<o.length;++i)o[i]=t.arguments[i];/function(?:\s+([\w$]+))+\s*\(/.test(t.toString())?r.push(new a({functionName:RegExp.$1||void 0,args:o})):r.push(new a({args:o}));try{t=t.caller}catch(e){break}}return r}})}();var stacktraceGps={exports:{}},sourceMapConsumer={},util$2={};
/* -*- Mode: js; js-indent-level: 2; -*- */
!function(s){s.getArg=
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
/**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */
function(e,r,n){if(r in e)return e[r];if(3===arguments.length)return n;throw new Error('"'+r+'" is a required argument.')};var r=/^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/,o=/^data:.+\,.+$/;function u(e){e=e.match(r);return e?{scheme:e[1],auth:e[2],host:e[3],port:e[4],path:e[5]}:null}function c(e){var r="";return e.scheme&&(r+=e.scheme+":"),r+="//",e.auth&&(r+=e.auth+"@"),e.host&&(r+=e.host),e.port&&(r+=":"+e.port),e.path&&(r+=e.path),r}
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */
function i(e){var r=e,n=u(e);if(n){if(!n.path)return e;r=n.path}for(var t,e=s.isAbsolute(r),o=r.split(/\/+/),i=0,a=o.length-1;0<=a;a--)"."===(t=o[a])?o.splice(a,1):".."===t?i++:0<i&&(""===t?(
// The first part is blank if the path is absolute. Trying to go
// above the root is a no-op. Therefore we can remove all '..' parts
// directly after the root.
o.splice(a+1,i),i=0):(o.splice(a,2),i--));return""===(r=o.join("/"))&&(r=e?"/":"."),n?(n.path=r,c(n)):r}s.urlParse=u,s.urlGenerate=c,s.normalize=i,s.join=
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */
function(e,r){""===e&&(e=".");var n=u(r=""===r?".":r),t=u(e);
// `join(foo, '//www.example.org')`
return t&&(e=t.path||"/"),n&&!n.scheme?(t&&(n.scheme=t.scheme),c(n)):n||r.match(o)?r:
// `join('http://', 'www.example.com')`
!t||t.host||t.path?(r="/"===r.charAt(0)?r:i(e.replace(/\/+$/,"")+"/"+r),t?(t.path=r,c(t)):r):(t.host=r,c(t))},s.isAbsolute=function(e){return"/"===e.charAt(0)||!!e.match(r)},s.relative=
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */
function(e,r){e=(e=""===e?".":e).replace(/\/$/,"");for(
// It is possible for the path to be above the root. In this case, simply
// checking whether the root is a prefix of the path won't work. Instead, we
// need to remove components from the root one by one, until either we find
// a prefix that fits, or we run out of components to remove.
var n=0;0!==r.indexOf(e+"/");){var t=e.lastIndexOf("/");if(t<0)return r;
// If the only part of the root that is left is the scheme (i.e. http://,
// file:///, etc.), one or more slashes (/), or simply nothing at all, we
// have exhausted all components, so the path is not relative to the root.
if((e=e.slice(0,t)).match(/^([^\/]+:\/)?\/*$/))return r;++n}
// Make sure we add a "../" for each component we removed from the root.
return Array(n+1).join("../")+r.substr(e.length+1)};var e=!("__proto__"in Object.create(null));function n(e){return e}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */function t(e){if(e){var r=e.length;if(!(r<9/* "__proto__".length */)&&95/* '_' */===e.charCodeAt(r-1)&&95/* '_' */===e.charCodeAt(r-2)&&111/* 'o' */===e.charCodeAt(r-3)&&116/* 't' */===e.charCodeAt(r-4)&&111/* 'o' */===e.charCodeAt(r-5)&&114/* 'r' */===e.charCodeAt(r-6)&&112/* 'p' */===e.charCodeAt(r-7)&&95/* '_' */===e.charCodeAt(r-8)&&95/* '_' */===e.charCodeAt(r-9)){for(var n=r-10;0<=n;n--)if(36/* '$' */!==e.charCodeAt(n))return;return 1}}}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */function a(e,r){return e===r?0:r<e?1:-1}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */s.toSetString=e?n:function(e){return t(e)?"$"+e:e},s.fromSetString=e?n:function(e){return t(e)?e.slice(1):e},s.compareByOriginalPositions=function(e,r,n){var t=e.source-r.source;return 0!==t||0!==(t=e.originalLine-r.originalLine)||0!==(t=e.originalColumn-r.originalColumn)||n||0!==(t=e.generatedColumn-r.generatedColumn)||0!==(t=e.generatedLine-r.generatedLine)?t:e.name-r.name},s.compareByGeneratedPositionsDeflated=
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */
function(e,r,n){var t=e.generatedLine-r.generatedLine;return 0!==t||0!==(t=e.generatedColumn-r.generatedColumn)||n||0!==(t=e.source-r.source)||0!==(t=e.originalLine-r.originalLine)||0!==(t=e.originalColumn-r.originalColumn)?t:e.name-r.name},s.compareByGeneratedPositionsInflated=function(e,r){var n=e.generatedLine-r.generatedLine;return 0!==n||0!==(n=e.generatedColumn-r.generatedColumn)||0!==(n=a(e.source,r.source))||0!==(n=e.originalLine-r.originalLine)||0!==(n=e.originalColumn-r.originalColumn)?n:a(e.name,r.name)}}(util$2);var binarySearch$1={};
/* -*- Mode: js; js-indent-level: 2; -*- */
!function(c){
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
c.GREATEST_LOWER_BOUND=1,c.LEAST_UPPER_BOUND=2,
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */
c.search=function(e,r,n,t){if(0===r.length)return-1;var o=
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */
function e(r,n,t,o,i,a){
// This function terminates when one of the following is true:
//
//   1. We find the exact element we are looking for.
//
//   2. We did not find the exact element, but we can return the index of
//      the next-closest element.
//
//   3. We did not find the exact element, and there is no next-closest
//      element than the one we are searching for, so we return -1.
var s=Math.floor((n-r)/2)+r,u=i(t,o[s],!0);return 0===u?s:0<u?
// Our needle is greater than aHaystack[mid].
1<n-s?e(s,n,t,o,i,a):
// The exact needle element was not found in this haystack. Determine if
// we are in termination case (3) or (2) and return the appropriate thing.
a==c.LEAST_UPPER_BOUND?n<o.length?n:-1:s:
// Our needle is less than aHaystack[mid].
1<s-r?e(r,s,t,o,i,a):
// we are in termination case (3) or (2) and return the appropriate thing.
a==c.LEAST_UPPER_BOUND?s:r<0?-1:r}(-1,r.length,e,r,n,t||c.GREATEST_LOWER_BOUND);if(o<0)return-1;
// We have found either the exact element, or the next-closest element than
// the one we are searching for. However, there may be more than one such
// element. Make sure we always return the smallest of these.
for(;0<=o-1&&0===n(r[o],r[o-1],!0);)--o;return o}}(binarySearch$1);var arraySet={},util$1=util$2,has=Object.prototype.hasOwnProperty;
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */
function ArraySet$1(){this._array=[],this._set=Object.create(null)}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ArraySet$1.fromArray=function(e,r){for(var n=new ArraySet$1,t=0,o=e.length;t<o;t++)n.add(e[t],r);return n},
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */
ArraySet$1.prototype.size=function(){return Object.getOwnPropertyNames(this._set).length},
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */
ArraySet$1.prototype.add=function(e,r){var n=util$1.toSetString(e),t=has.call(this._set,n),o=this._array.length;t&&!r||this._array.push(e),t||(this._set[n]=o)},
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */
ArraySet$1.prototype.has=function(e){e=util$1.toSetString(e);return has.call(this._set,e)},
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */
ArraySet$1.prototype.indexOf=function(e){var r=util$1.toSetString(e);if(has.call(this._set,r))return this._set[r];throw new Error('"'+e+'" is not in the set.')},
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */
ArraySet$1.prototype.at=function(e){if(0<=e&&e<this._array.length)return this._array[e];throw new Error("No element indexed by "+e)},
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */
ArraySet$1.prototype.toArray=function(){return this._array.slice()},arraySet.ArraySet=ArraySet$1;var base64Vlq={},base64$1={},intToCharMap="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */
base64$1.encode=function(e){if(0<=e&&e<intToCharMap.length)return intToCharMap[e];throw new TypeError("Must be between 0 and 63: "+e)},
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */
base64$1.decode=function(e){
// 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
return 65<=e&&e<=90?e-65:
// 26 - 51: abcdefghijklmnopqrstuvwxyz
97<=e&&e<=122?e-97+26:
// 52 - 61: 0123456789
48<=e&&e<=57?e-48+52:
// 62: +
43==e?62:
// 63: /
47==e?63:-1};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var base64=base64$1,VLQ_BASE_SHIFT=5,VLQ_BASE=1<<VLQ_BASE_SHIFT,VLQ_BASE_MASK=VLQ_BASE-1,VLQ_CONTINUATION_BIT=VLQ_BASE;
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */
function toVLQSigned(e){return e<0?1+(-e<<1):e<<1}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */function fromVLQSigned(e){var r=e>>1;return 1==(1&e)?-r:r}
/**
 * Returns the base 64 VLQ encoded value.
 */base64Vlq.encode=function(e){for(var r,n="",t=toVLQSigned(e);r=t&VLQ_BASE_MASK,0<(t>>>=VLQ_BASE_SHIFT)&&(
// There are still more digits in this value, so we must make sure the
// continuation bit is marked.
r|=VLQ_CONTINUATION_BIT),n+=base64.encode(r),0<t;);return n},
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */
base64Vlq.decode=function(e,r,n){var t,o,i=e.length,a=0,s=0;do{if(i<=r)throw new Error("Expected more digits in base 64 VLQ value.");if(-1===(o=base64.decode(e.charCodeAt(r++))))throw new Error("Invalid base64 digit: "+e.charAt(r-1))}while(t=!!(o&VLQ_CONTINUATION_BIT),a+=(o&=VLQ_BASE_MASK)<<s,s+=VLQ_BASE_SHIFT,t);n.value=fromVLQSigned(a),n.rest=r};var quickSort$1={};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
// It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */function swap(e,r,n){var t=e[r];e[r]=e[n],e[n]=t}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */function randomIntInRange(e,r){return Math.round(e+Math.random()*(r-e))}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */function doQuickSort(e,r,n,t){
// If our lower bound is less than our upper bound, we (1) partition the
// array into two pieces and (2) recurse on each half. If it is not, this is
// the empty array and our base case.
if(n<t){
// (1) Partitioning.
//
// The partitioning chooses a pivot between `p` and `r` and moves all
// elements that are less than or equal to the pivot to the before it, and
// all the elements that are greater than it after it. The effect is that
// once partition is done, the pivot is in the exact place it will be when
// the array is put in sorted order, and it will not need to be moved
// again. This runs in O(n) time.
// Always choose a random pivot so that an input array which is reverse
// sorted does not cause O(n^2) running time.
var o=n-1;swap(e,randomIntInRange(n,t),t);
// Immediately after `j` is incremented in this loop, the following hold
// true:
//
//   * Every element in `ary[p .. i]` is less than or equal to the pivot.
//
//   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
for(var i=e[t],a=n;a<t;a++)r(e[a],i)<=0&&swap(e,o+=1,a);swap(e,o+1,a);var s=o+1;
// (2) Recurse on each half.
doQuickSort(e,r,n,s-1),doQuickSort(e,r,s+1,t)}}
/**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */quickSort$1.quickSort=function(e,r){doQuickSort(e,r,0,e.length-1)};
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
var util=util$2,binarySearch=binarySearch$1,ArraySet=arraySet.ArraySet,base64VLQ=base64Vlq,quickSort=quickSort$1.quickSort;function SourceMapConsumer(e){var r=e;return new(null!=(r="string"==typeof e?JSON.parse(e.replace(/^\)\]\}'/,"")):r).sections?IndexedSourceMapConsumer:BasicSourceMapConsumer)(r)}
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The only parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */
function BasicSourceMapConsumer(e){var r=e;"string"==typeof e&&(r=JSON.parse(e.replace(/^\)\]\}'/,"")));var n=util.getArg(r,"version"),t=util.getArg(r,"sources"),o=util.getArg(r,"names",[]),i=util.getArg(r,"sourceRoot",null),a=util.getArg(r,"sourcesContent",null),e=util.getArg(r,"mappings"),r=util.getArg(r,"file",null);
// Once again, Sass deviates from the spec and supplies the version as a
// string rather than a number, so we use loose equality checking here.
if(n!=this._version)throw new Error("Unsupported version: "+n);t=t.map(String).map(util.normalize).map(function(e){return i&&util.isAbsolute(i)&&util.isAbsolute(e)?util.relative(i,e):e}),
// Pass `true` below to allow duplicate names and sources. While source maps
// are intended to be compressed and deduplicated, the TypeScript compiler
// sometimes generates source maps with duplicates in them. See Github issue
// #72 and bugzil.la/889492.
this._names=ArraySet.fromArray(o.map(String),!0),this._sources=ArraySet.fromArray(t,!0),this.sourceRoot=i,this.sourcesContent=a,this._mappings=e,this.file=r}
/**
 * Provide the JIT with a nice shape / hidden class.
 */
function Mapping(){this.generatedLine=0,this.generatedColumn=0,this.source=null,this.originalLine=null,this.originalColumn=null,this.name=null}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The only parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */
function IndexedSourceMapConsumer(e){var r=e;"string"==typeof e&&(r=JSON.parse(e.replace(/^\)\]\}'/,"")));e=util.getArg(r,"version"),r=util.getArg(r,"sections");if(e!=this._version)throw new Error("Unsupported version: "+e);this._sources=new ArraySet,this._names=new ArraySet;var o={line:-1,column:0};this._sections=r.map(function(e){if(e.url)
// The url field will require support for asynchronicity.
// See https://github.com/mozilla/source-map/issues/16
throw new Error("Support for url field in sections not implemented.");var r=util.getArg(e,"offset"),n=util.getArg(r,"line"),t=util.getArg(r,"column");if(n<o.line||n===o.line&&t<o.column)throw new Error("Section offsets must be ordered and non-overlapping.");return o=r,{generatedOffset:{
// The offset fields are 0-based, but we use 1-based indices when
// encoding/decoding from VLQ.
generatedLine:n+1,generatedColumn:t+1},consumer:new SourceMapConsumer(util.getArg(e,"map"))}})}SourceMapConsumer.fromSourceMap=function(e){return BasicSourceMapConsumer.fromSourceMap(e)},
/**
 * The version of the source mapping spec that we are consuming.
 */
SourceMapConsumer.prototype._version=3,
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
SourceMapConsumer.prototype.__generatedMappings=null,Object.defineProperty(SourceMapConsumer.prototype,"_generatedMappings",{get:function(){return this.__generatedMappings||this._parseMappings(this._mappings,this.sourceRoot),this.__generatedMappings}}),SourceMapConsumer.prototype.__originalMappings=null,Object.defineProperty(SourceMapConsumer.prototype,"_originalMappings",{get:function(){return this.__originalMappings||this._parseMappings(this._mappings,this.sourceRoot),this.__originalMappings}}),SourceMapConsumer.prototype._charIsMappingSeparator=function(e,r){r=e.charAt(r);return";"===r||","===r},
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
SourceMapConsumer.prototype._parseMappings=function(e,r){throw new Error("Subclasses must implement _parseMappings")},SourceMapConsumer.GENERATED_ORDER=1,SourceMapConsumer.ORIGINAL_ORDER=2,SourceMapConsumer.GREATEST_LOWER_BOUND=1,SourceMapConsumer.LEAST_UPPER_BOUND=2,
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */
SourceMapConsumer.prototype.eachMapping=function(e,r,n){var t,r=r||null;switch(n||SourceMapConsumer.GENERATED_ORDER){case SourceMapConsumer.GENERATED_ORDER:t=this._generatedMappings;break;case SourceMapConsumer.ORIGINAL_ORDER:t=this._originalMappings;break;default:throw new Error("Unknown order of iteration.")}var o=this.sourceRoot;t.map(function(e){var r=null===e.source?null:this._sources.at(e.source);return{source:r=null!=r&&null!=o?util.join(o,r):r,generatedLine:e.generatedLine,generatedColumn:e.generatedColumn,originalLine:e.originalLine,originalColumn:e.originalColumn,name:null===e.name?null:this._names.at(e.name)}},this).forEach(e,r)},
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: Optional. the column number in the original source.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
SourceMapConsumer.prototype.allGeneratedPositionsFor=function(e){var r=util.getArg(e,"line"),n={source:util.getArg(e,"source"),originalLine:r,originalColumn:util.getArg(e,"column",0)};
// When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
// returns the index of the closest mapping less than the needle. By
// setting needle.originalColumn to 0, we thus find the last mapping for
// the given line, provided such a mapping exists.
if(null!=this.sourceRoot&&(n.source=util.relative(this.sourceRoot,n.source)),!this._sources.has(n.source))return[];n.source=this._sources.indexOf(n.source);var t=[],o=this._findMapping(n,this._originalMappings,"originalLine","originalColumn",util.compareByOriginalPositions,binarySearch.LEAST_UPPER_BOUND);if(0<=o){var i=this._originalMappings[o];if(void 0===e.column)
// Iterate until either we run out of mappings, or we run into
// a mapping for a different line than the one we found. Since
// mappings are sorted, this is guaranteed to find all mappings for
// the line we found.
for(var a=i.originalLine;i&&i.originalLine===a;)t.push({line:util.getArg(i,"generatedLine",null),column:util.getArg(i,"generatedColumn",null),lastColumn:util.getArg(i,"lastGeneratedColumn",null)}),i=this._originalMappings[++o];else
// Iterate until either we run out of mappings, or we run into
// a mapping for a different line than the one we were searching for.
// Since mappings are sorted, this is guaranteed to find all mappings for
// the line we are searching for.
for(var s=i.originalColumn;i&&i.originalLine===r&&i.originalColumn==s;)t.push({line:util.getArg(i,"generatedLine",null),column:util.getArg(i,"generatedColumn",null),lastColumn:util.getArg(i,"lastGeneratedColumn",null)}),i=this._originalMappings[++o]}return t},sourceMapConsumer.SourceMapConsumer=SourceMapConsumer,BasicSourceMapConsumer.prototype=Object.create(SourceMapConsumer.prototype),BasicSourceMapConsumer.prototype.consumer=SourceMapConsumer,
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @returns BasicSourceMapConsumer
 */
BasicSourceMapConsumer.fromSourceMap=function(e){var r=Object.create(BasicSourceMapConsumer.prototype),n=r._names=ArraySet.fromArray(e._names.toArray(),!0),t=r._sources=ArraySet.fromArray(e._sources.toArray(),!0);r.sourceRoot=e._sourceRoot,r.sourcesContent=e._generateSourcesContent(r._sources.toArray(),r.sourceRoot),r.file=e._file;for(
// Because we are modifying the entries (by converting string sources and
// names to indices into the sources and names ArraySets), we have to make
// a copy of the entry or else bad things happen. Shared mutable state
// strikes again! See github issue #191.
var o=e._mappings.toArray().slice(),i=r.__generatedMappings=[],a=r.__originalMappings=[],s=0,u=o.length;s<u;s++){var c=o[s],l=new Mapping;l.generatedLine=c.generatedLine,l.generatedColumn=c.generatedColumn,c.source&&(l.source=t.indexOf(c.source),l.originalLine=c.originalLine,l.originalColumn=c.originalColumn,c.name&&(l.name=n.indexOf(c.name)),a.push(l)),i.push(l)}return quickSort(r.__originalMappings,util.compareByOriginalPositions),r},
/**
 * The version of the source mapping spec that we are consuming.
 */
BasicSourceMapConsumer.prototype._version=3,
/**
 * The list of original sources.
 */
Object.defineProperty(BasicSourceMapConsumer.prototype,"sources",{get:function(){return this._sources.toArray().map(function(e){return null!=this.sourceRoot?util.join(this.sourceRoot,e):e},this)}}),BasicSourceMapConsumer.prototype._parseMappings=function(e,r){for(var n,t,o,i,a=1,s=0,u=0,c=0,l=0,p=0,f=e.length,g=0,h={},m={},d=[],v=[];g<f;)if(";"===e.charAt(g))a++,g++,s=0;else if(","===e.charAt(g))g++;else{
// Because each offset is encoded relative to the previous one,
// many segments often have the same encoding. We can exploit this
// fact by caching the parsed variable length fields of each segment,
// allowing us to avoid a second parse if we encounter the same
// segment again.
for((n=new Mapping).generatedLine=a,i=g;i<f&&!this._charIsMappingSeparator(e,i);i++);if(o=h[t=e.slice(g,i)])g+=t.length;else{for(o=[];g<i;)base64VLQ.decode(e,g,m),g=m.rest,o.push(m.value);if(2===o.length)throw new Error("Found a source, but no line and column");if(3===o.length)throw new Error("Found a source and line, but no column");h[t]=o}
// Generated column.
n.generatedColumn=s+o[0],s=n.generatedColumn,1<o.length&&(
// Original source.
n.source=l+o[1],l+=o[1],
// Original line.
n.originalLine=u+o[2],u=n.originalLine,
// Lines are stored 0-based
n.originalLine+=1,
// Original column.
n.originalColumn=c+o[3],c=n.originalColumn,4<o.length&&(
// Original name.
n.name=p+o[4],p+=o[4])),v.push(n),"number"==typeof n.originalLine&&d.push(n)}quickSort(v,util.compareByGeneratedPositionsDeflated),this.__generatedMappings=v,quickSort(d,util.compareByOriginalPositions),this.__originalMappings=d},
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */
BasicSourceMapConsumer.prototype._findMapping=function(e,r,n,t,o,i){
// To return the position we are searching for, we must first find the
// mapping for the given position and then return the opposite position it
// points to. Because the mappings are sorted, we can use binary search to
// find the best mapping.
if(e[n]<=0)throw new TypeError("Line must be greater than or equal to 1, got "+e[n]);if(e[t]<0)throw new TypeError("Column must be greater than or equal to 0, got "+e[t]);return binarySearch.search(e,r,o,i)},
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */
BasicSourceMapConsumer.prototype.computeColumnSpans=function(){for(var e=0;e<this._generatedMappings.length;++e){var r=this._generatedMappings[e];
// Mappings do not contain a field for the last generated columnt. We
// can come up with an optimistic estimate, however, by assuming that
// mappings are contiguous (i.e. given two consecutive mappings, the
// first mapping ends where the second one starts).
if(e+1<this._generatedMappings.length){var n=this._generatedMappings[e+1];if(r.generatedLine===n.generatedLine){r.lastGeneratedColumn=n.generatedColumn-1;continue}}
// The last mapping for each line spans the entire line.
r.lastGeneratedColumn=1/0}},
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */
BasicSourceMapConsumer.prototype.originalPositionFor=function(e){var r={generatedLine:util.getArg(e,"line"),generatedColumn:util.getArg(e,"column")},n=this._findMapping(r,this._generatedMappings,"generatedLine","generatedColumn",util.compareByGeneratedPositionsDeflated,util.getArg(e,"bias",SourceMapConsumer.GREATEST_LOWER_BOUND));if(0<=n){e=this._generatedMappings[n];if(e.generatedLine===r.generatedLine){n=util.getArg(e,"source",null);null!==n&&(n=this._sources.at(n),null!=this.sourceRoot&&(n=util.join(this.sourceRoot,n)));r=util.getArg(e,"name",null);return null!==r&&(r=this._names.at(r)),{source:n,line:util.getArg(e,"originalLine",null),column:util.getArg(e,"originalColumn",null),name:r}}}return{source:null,line:null,column:null,name:null}},
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
BasicSourceMapConsumer.prototype.hasContentsOfAllSources=function(){return!!this.sourcesContent&&(this.sourcesContent.length>=this._sources.size()&&!this.sourcesContent.some(function(e){return null==e}))},
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
BasicSourceMapConsumer.prototype.sourceContentFor=function(e,r){if(!this.sourcesContent)return null;if(null!=this.sourceRoot&&(e=util.relative(this.sourceRoot,e)),this._sources.has(e))return this.sourcesContent[this._sources.indexOf(e)];var n;if(null!=this.sourceRoot&&(n=util.urlParse(this.sourceRoot))){
// XXX: file:// URIs and absolute paths lead to unexpected behavior for
// many users. We can help them out when they expect file:// URIs to
// behave like it would if they were running a local HTTP server. See
// https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
var t=e.replace(/^file:\/\//,"");if("file"==n.scheme&&this._sources.has(t))return this.sourcesContent[this._sources.indexOf(t)];if((!n.path||"/"==n.path)&&this._sources.has("/"+e))return this.sourcesContent[this._sources.indexOf("/"+e)]}
// This function is used recursively from
// IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
// don't want to throw if we can't find the source - we just want to
// return null, so we provide a flag to exit gracefully.
if(r)return null;throw new Error('"'+e+'" is not in the SourceMap.')},
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
BasicSourceMapConsumer.prototype.generatedPositionFor=function(e){var r=util.getArg(e,"source");if(null!=this.sourceRoot&&(r=util.relative(this.sourceRoot,r)),!this._sources.has(r))return{line:null,column:null,lastColumn:null};r={source:r=this._sources.indexOf(r),originalLine:util.getArg(e,"line"),originalColumn:util.getArg(e,"column")},e=this._findMapping(r,this._originalMappings,"originalLine","originalColumn",util.compareByOriginalPositions,util.getArg(e,"bias",SourceMapConsumer.GREATEST_LOWER_BOUND));if(0<=e){e=this._originalMappings[e];if(e.source===r.source)return{line:util.getArg(e,"generatedLine",null),column:util.getArg(e,"generatedColumn",null),lastColumn:util.getArg(e,"lastGeneratedColumn",null)}}return{line:null,column:null,lastColumn:null}},sourceMapConsumer.BasicSourceMapConsumer=BasicSourceMapConsumer,IndexedSourceMapConsumer.prototype=Object.create(SourceMapConsumer.prototype),IndexedSourceMapConsumer.prototype.constructor=SourceMapConsumer,
/**
 * The version of the source mapping spec that we are consuming.
 */
IndexedSourceMapConsumer.prototype._version=3,
/**
 * The list of original sources.
 */
Object.defineProperty(IndexedSourceMapConsumer.prototype,"sources",{get:function(){for(var e=[],r=0;r<this._sections.length;r++)for(var n=0;n<this._sections[r].consumer.sources.length;n++)e.push(this._sections[r].consumer.sources[n]);return e}}),
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */
IndexedSourceMapConsumer.prototype.originalPositionFor=function(e){var r={generatedLine:util.getArg(e,"line"),generatedColumn:util.getArg(e,"column")},n=binarySearch.search(r,this._sections,function(e,r){var n=e.generatedLine-r.generatedOffset.generatedLine;return n||e.generatedColumn-r.generatedOffset.generatedColumn}),n=this._sections[n];
// Find the section containing the generated position we're trying to map
// to an original position.
return n?n.consumer.originalPositionFor({line:r.generatedLine-(n.generatedOffset.generatedLine-1),column:r.generatedColumn-(n.generatedOffset.generatedLine===r.generatedLine?n.generatedOffset.generatedColumn-1:0),bias:e.bias}):{source:null,line:null,column:null,name:null}},
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
IndexedSourceMapConsumer.prototype.hasContentsOfAllSources=function(){return this._sections.every(function(e){return e.consumer.hasContentsOfAllSources()})},
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
IndexedSourceMapConsumer.prototype.sourceContentFor=function(e,r){for(var n=0;n<this._sections.length;n++){var t=this._sections[n].consumer.sourceContentFor(e,!0);if(t)return t}if(r)return null;throw new Error('"'+e+'" is not in the SourceMap.')},
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */
IndexedSourceMapConsumer.prototype.generatedPositionFor=function(e){for(var r=0;r<this._sections.length;r++){var n=this._sections[r];
// Only consider this section if the requested source is in the list of
// sources of the consumer.
if(-1!==n.consumer.sources.indexOf(util.getArg(e,"source"))){var t=n.consumer.generatedPositionFor(e);if(t)return{line:t.line+(n.generatedOffset.generatedLine-1),column:t.column+(n.generatedOffset.generatedLine===t.line?n.generatedOffset.generatedColumn-1:0)}}}return{line:null,column:null}},
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
IndexedSourceMapConsumer.prototype._parseMappings=function(e,r){this.__generatedMappings=[],this.__originalMappings=[];for(var n=0;n<this._sections.length;n++)for(var t=this._sections[n],o=t.consumer._generatedMappings,i=0;i<o.length;i++){var a=o[i],s=t.consumer._sources.at(a.source);null!==t.consumer.sourceRoot&&(s=util.join(t.consumer.sourceRoot,s)),this._sources.add(s);var s=this._sources.indexOf(s),u=t.consumer._names.at(a.name);this._names.add(u);
// The mappings coming from the consumer for the section have
// generated positions relative to the start of the section, so we
// need to offset them to be relative to the start of the concatenated
// generated file.
u=this._names.indexOf(u),u={source:s,generatedLine:a.generatedLine+(t.generatedOffset.generatedLine-1),generatedColumn:a.generatedColumn+(t.generatedOffset.generatedLine===a.generatedLine?t.generatedOffset.generatedColumn-1:0),originalLine:a.originalLine,originalColumn:a.originalColumn,name:u};this.__generatedMappings.push(u),"number"==typeof u.originalLine&&this.__originalMappings.push(u)}quickSort(this.__generatedMappings,util.compareByGeneratedPositionsDeflated),quickSort(this.__originalMappings,util.compareByOriginalPositions)},sourceMapConsumer.IndexedSourceMapConsumer=IndexedSourceMapConsumer,function(){
/**
     * Make a X-Domain request to url and callback.
     *
     * @param {String} url
     * @returns {Promise} with response text if fulfilled
     */
function r(t){return new Promise(function(e,r){var n=new XMLHttpRequest;n.open("get",t),n.onerror=r,n.onreadystatechange=function(){4===n.readyState&&(200<=n.status&&n.status<300||"file://"===t.substr(0,7)&&n.responseText?e(n.responseText):r(new Error("HTTP status: "+n.status+" retrieving "+t)))},n.send()})}
/**
     * Convert a Base64-encoded string into its original representation.
     * Used for inline sourcemaps.
     *
     * @param {String} b64str Base-64 encoded string
     * @returns {String} original representation of the base64-encoded string.
     */function n(e){if("undefined"!=typeof window&&window.atob)return window.atob(e);throw new Error("You must supply a polyfill for window.atob in this environment")}function a(e){if("object"!=typeof e)throw new TypeError("Given StackFrame is not an object");if("string"!=typeof e.fileName)throw new TypeError("Given file name is not a String");if("number"!=typeof e.lineNumber||e.lineNumber%1!=0||e.lineNumber<1)throw new TypeError("Given line number must be a positive integer");if("number"!=typeof e.columnNumber||e.columnNumber%1!=0||e.columnNumber<0)throw new TypeError("Given column number must be a non-negative integer");return 1}var o,c;stacktraceGps.exports=(o=sourceMapConsumer,c=stackframe.exports,function e(i){if(!(this instanceof e))return new e(i);i=i||{},this.sourceCache=i.sourceCache||{},this.sourceMapConsumerCache=i.sourceMapConsumerCache||{},this.ajax=i.ajax||r,this._atob=i.atob||n,this._get=function(o){return new Promise(function(e,r){var n,t="data:"===o.substr(0,5);this.sourceCache[o]?e(this.sourceCache[o]):i.offline&&!t?r(new Error("Cannot make network requests in offline mode")):t?(t=o.match(/^data:application\/json;([\w=:"-]+;)*base64,/))?(n=t[0].length,n=o.substr(n),n=this._atob(n),e(this.sourceCache[o]=n)):r(new Error("The encoding of the inline sourcemap is not supported")):(n=this.ajax(o,{method:"get"}),(
// Cache the Promise to prevent duplicate in-flight requests
this.sourceCache[o]=n).then(e,r))}.bind(this))},
/**
         * Creating SourceMapConsumers is expensive, so this wraps the creation of a
         * SourceMapConsumer in a per-instance cache.
         *
         * @param {String} sourceMappingURL = URL to fetch source map from
         * @param {String} defaultSourceRoot = Default source root for source map if undefined
         * @returns {Promise} that resolves a SourceMapConsumer
         */
this._getSourceMapConsumer=function(n,t){return new Promise(function(e){var r;this.sourceMapConsumerCache[n]?e(this.sourceMapConsumerCache[n]):(r=new Promise(function(r,e){return this._get(n).then(function(e){void 0===(e="string"==typeof e?function(e){{if("undefined"!=typeof JSON&&JSON.parse)return JSON.parse(e);throw new Error("You must supply a polyfill for JSON.parse in this environment")}}(e.replace(/^\)\]\}'/,"")):e).sourceRoot&&(e.sourceRoot=t),r(new o.SourceMapConsumer(e))},e)}.bind(this)),e(this.sourceMapConsumerCache[n]=r))}.bind(this))},
/**
         * Given a StackFrame, enhance function name and use source maps for a
         * better StackFrame.
         *
         * @param {StackFrame} stackframe object
         * @returns {Promise} that resolves with with source-mapped StackFrame
         */
this.pinpoint=function(r){return new Promise(function(n,e){this.getMappedLocation(r).then(function(e){function r(){n(e)}this.findFunctionName(e).then(n,r).catch(r)}.bind(this),e)}.bind(this))},
/**
         * Given a StackFrame, guess function name from location information.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */
this.findFunctionName=function(o){return new Promise(function(t,e){a(o),this._get(o.fileName).then(function(e){var r=o.lineNumber,n=o.columnNumber,e=function(e,r/*, columnNumber*/){for(var n=[
// {name} = function ({args}) TODO args capture
/['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*function\b/,
// function {name}({args}) m[1]=name m[2]=args
/function\s+([^('"`]*?)\s*\(([^)]*)\)/,
// {name} = eval()
/['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*(?:eval|new Function)\b/,
// fn_name() {
/\b(?!(?:if|for|switch|while|with|catch)\b)(?:(?:static)\s+)?(\S+)\s*\(.*?\)\s*\{/,
// {name} = () => {
/['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*\(.*?\)\s*=>/],t=e.split("\n"),o="",i=Math.min(r,20),a=0;a<i;++a){
// lineNo is 1-based, source[] is 0-based
var s=t[r-a-1],u=s.indexOf("//");if(s=0<=u?s.substr(0,u):s){o=s+o;for(var c=n.length,l=0;l<c;l++){var p=n[l].exec(o);if(p&&p[1])return p[1]}}}return}(e,r);t(
// Only replace functionName if we found something
e?new c({functionName:e,args:o.args,fileName:o.fileName,lineNumber:r,columnNumber:n}):o)},e).catch(e)}.bind(this))},
/**
         * Given a StackFrame, seek source-mapped location and return new enhanced StackFrame.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */
this.getMappedLocation=function(u){return new Promise(function(t,e){!function(){if("function"!=typeof Object.defineProperty||"function"!=typeof Object.create)throw new Error("Unable to consume source maps in older browsers")}(),a(u);var s=this.sourceCache,o=u.fileName;this._get(o).then(function(e){var r=function(e){var r,n,t=/\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/gm;
// eslint-disable-next-line no-cond-assign
for(;n=t.exec(e);)r=n[1];{if(r)return r;throw new Error("sourceMappingURL not found")}}(e),n="data:"===r.substr(0,5),e=o.substring(0,o.lastIndexOf("/")+1);return"/"===r[0]||n||/^https?:\/\/|^\/\//i.test(r)||(r=e+r),this._getSourceMapConsumer(r,e).then(function(e){return o=u,i=e,a=s,new Promise(function(e,r){var n,t=i.originalPositionFor({line:o.lineNumber,column:o.columnNumber});t.source?((n=i.sourceContentFor(t.source))&&(a[t.source]=n),e(
// given stackframe and source location, update stackframe
new c({functionName:t.name||o.functionName,args:o.args,fileName:t.source,lineNumber:t.line,columnNumber:t.column}))):r(new Error("Could not get original source for given stackframe and source map"))}).then(t).catch(function(){t(u)});var o,i,a;
/**
     * @constructor
     * @param {Object} opts
     *      opts.sourceCache = {url: "Source String"} => preload source cache
     *      opts.sourceMapConsumerCache = {/path/file.js.map: SourceMapConsumer}
     *      opts.offline = True to prevent network requests.
     *              Best effort without sources or source maps.
     *      opts.ajax = Promise returning function to make X-Domain requests
     */})}.bind(this),e).catch(e)}.bind(this))}})}(),function(){function n(){try{
// Error must be thrown to get stack in IE
throw new Error}catch(e){return e}}
/**
     * Merge 2 given Objects. If a conflict occurs the second object wins.
     * Does not do deep merges.
     *
     * @param {Object} first base object
     * @param {Object} second overrides
     * @returns {Object} merged first and second
     * @private
     */
function i(e,r){var n={};return[e,r].forEach(function(e){for(var r in e)e.hasOwnProperty(r)&&(n[r]=e[r]);return n}),n}function a(e){return e.stack||e["opera#sourceloc"]}function s(e,r){return"function"==typeof r?e.filter(r):e}var u,t,e,c;stacktrace.exports=(u=errorStackParser.exports,t=stackGenerator.exports,e=stacktraceGps.exports,c={filter:function(e){
// Filter out stackframes for this library by default
return-1===(e.functionName||"").indexOf("StackTrace$$")&&-1===(e.functionName||"").indexOf("ErrorStackParser$$")&&-1===(e.functionName||"").indexOf("StackTraceGPS$$")&&-1===(e.functionName||"").indexOf("StackGenerator$$")},sourceCache:{}},{
/**
         * Get a backtrace from invocation point.
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */
get:function(e){var r=n();return a(r)?this.fromError(r,e):this.generateArtificially(e)},
/**
         * Get a backtrace from invocation point.
         * IMPORTANT: Does not handle source maps or guess function names!
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */
getSync:function(e){e=i(c,e);var r=n();return s(a(r)?u.parse(r):t.backtrace(e),e.filter)},
/**
         * Given an error object, parse it.
         *
         * @param {Error} error object
         * @param {Object} opts
         * @returns {Promise} for Array[StackFrame}
         */
fromError:function(n,t){t=i(c,t);var o=new e(t);return new Promise(function(e){var r=s(u.parse(n),t.filter);e(Promise.all(r.map(function(n){return new Promise(function(e){function r(){e(n)}o.pinpoint(n).then(e,r).catch(r)})})))}.bind(this))},
/**
         * Use StackGenerator to generate a backtrace.
         *
         * @param {Object} opts
         * @returns {Promise} of Array[StackFrame]
         */
generateArtificially:function(e){e=i(c,e);var r=t.backtrace(e);return"function"==typeof e.filter&&(r=r.filter(e.filter)),Promise.resolve(r)},
/**
         * Given a function, wrap it such that invocations trigger a callback that
         * is called with a stack trace.
         *
         * @param {Function} fn to be instrumented
         * @param {Function} callback function to call with a stack trace on invocation
         * @param {Function} errback optional function to call with error if unable to get stack trace.
         * @param {Object} thisArg optional context object (e.g. window)
         */
instrument:function(e,r,n,t){if("function"!=typeof e)throw new Error("Cannot instrument non-function object");if("function"==typeof e.__stacktraceOriginalFn)
// Already instrumented, return given Function
return e;var o=function(){try{return this.get().then(r,n).catch(n),e.apply(t||this,arguments)}catch(e){throw a(e)&&this.fromError(e).then(r,n).catch(n),e}}.bind(this);return o.__stacktraceOriginalFn=e,o},
/**
         * Given a function that has been instrumented,
         * revert the function to it's original (non-instrumented) state.
         *
         * @param {Function} fn to de-instrument
         */
deinstrument:function(e){if("function"!=typeof e)throw new Error("Cannot de-instrument non-function object");return"function"==typeof e.__stacktraceOriginalFn?e.__stacktraceOriginalFn:e},
/**
         * Given an error message and Array of StackFrames, serialize and POST to given URL.
         *
         * @param {Array} stackframes
         * @param {String} url
         * @param {String} errorMsg
         * @param {Object} requestOptions
         */
report:function(a,s,u,c){return new Promise(function(e,r){var n=new XMLHttpRequest;if(n.onerror=r,n.onreadystatechange=function(){4===n.readyState&&(200<=n.status&&n.status<400?e(n.responseText):r(new Error("POST to "+s+" failed with status: "+n.status)))},n.open("post",s),
// Set request headers
n.setRequestHeader("Content-Type","application/json"),c&&"object"==typeof c.headers){var t,o=c.headers;for(t in o)o.hasOwnProperty(t)&&n.setRequestHeader(t,o[t])}var i={stack:a};null!=u&&(i.message=u),n.send(JSON.stringify(i))})}})}();var ErrorType,StackTrace=stacktrace.exports,isEaiError=function(e){return(null==e?void 0:e.code)===serviceAsync.GjeFetchErrorCode.EAI_ERROR},EAI_REASON_MAP={"0x38cf04d3":"Could not read the response status line sent by a third-party server. Possible causes: non-spec HTTP headers, connection timeout, no data returned. This is not a problem with the WebSEAL server.","0x38cf025f":"Received basic authentication challenge for junction where filtering is being applied","0x00000000":"Successful completion"};function getEaiExtras(e){if(!e||!e.message)return[];e=e.message.match(/\(url=(.*)\)/);if(!e||e.length<=1)return[];e=e[1];if(void 0===e||0===e.length||-1===e.indexOf("/eai/op"))return[];e=serviceQuerystring.parseQuery(e);return Object.entries(e).reduce(function(e,r){var n=__read(r,2),r=n[0],n=n[1];return __spreadArray(__spreadArray([],__read(e),!1),[{key:"eai.".concat(r.toLowerCase()),value:Array.isArray(n)?n.toString():decodeURIComponent(n||"")}],!1)},[{key:"eai.reason",value:EAI_REASON_MAP[e.ERROR_CODE]||"Unknown"}])}!function(e){e.APP="APP",e.NETWORK="NETWORK",e.MESSAGE="MESSAGE"}(ErrorType=ErrorType||{});var triggeredEvents=[];function eventListener(e){triggeredEvents.push(e.type)}function performLogRequest(e){var n=e.errorType,t=e.severity,o=__rest(e,["errorType","severity"]);return __awaiter(this,void 0,void 0,function(){var r;return __generator(this,function(e){switch(e.label){case 0:return[4,serviceAsync.apiFetcher.postJson("/api-tools/v1/open/remote-logging/".concat(n,"?severity=").concat(t||"ERROR"),{body:__assign({},o)})];case 1:return(r=e.sent()).isErr()&&console.error("Failed to remote log error",r.error),[2]}})})}window.addEventListener("pagehide",eventListener),window.addEventListener("beforeunload",eventListener),window.addEventListener("unload",eventListener);var getStackTrace=function(r){return __awaiter(void 0,void 0,void 0,function(){return __generator(this,function(e){switch(e.label){case 0:if(!r)return[2,void 0];e.label=1;case 1:return e.trys.push([1,3,,4]),[4,StackTrace.fromError(r)];case 2:return[2,e.sent()];case 3:return e.sent(),[2,void 0];case 4:return[2]}})})},objectToKeyValueArray=function(e){return Object.entries(e).map(function(e){var r=__read(e,2),e=r[0],r=r[1];return{key:e,value:"string"==typeof r?r:JSON.stringify(r)}})},remoteLogWindowOnError=function(t,o,i,a,s){return __awaiter(void 0,void 0,void 0,function(){var r,n;return __generator(this,function(e){switch(e.label){case 0:return r=performLogRequest,n={errorType:ErrorType.APP,severity:"Script error."===t?"WARN":"ERROR",message:s?s.message:"Message not available because error object is null"},[4,getStackTrace(s)];case 1:return[2,r.apply(void 0,[(n.stackTrace=e.sent(),n.extras=objectToKeyValueArray({msg:t,url:o,lineNo:i,columnNo:a,location:window&&window.location||"window.onerror"}),n)])]}})})},remoteLogAppError=function(t,o){return void 0===o&&(o={}),__awaiter(void 0,void 0,void 0,function(){var r,n;return __generator(this,function(e){switch(e.label){case 0:return r=performLogRequest,n={errorType:ErrorType.APP,message:t?t.message:"Message not available because error object is null"},[4,getStackTrace(t)];case 1:return[2,r.apply(void 0,[__assign.apply(void 0,[(n.stackTrace=e.sent(),n),o])])]}})})},isValidationError=function(e){return"parameter_invalid"===(null==e?void 0:e.code)},isUnknownFetchError=function(e){return(null==e?void 0:e.code)===serviceAsync.GjeFetchErrorCode.UNKNOWN_FETCH_ERROR},remoteLogFetchError=function(e,r,n){void 0===n&&(n={});var t=[];return isValidationError(r)?t.push.apply(t,__spreadArray([],__read(r.extras.map(function(e,r){return{key:"field".concat(r+1),value:"[fieldName=".concat(e.field,', message="').concat(e.message,'"]')}})),!1)):isEaiError(r)?t.push.apply(t,__spreadArray([],__read(getEaiExtras(r)),!1)):isUnknownFetchError(r)&&0<triggeredEvents.length&&(n.severity="WARN"),performLogRequest({errorType:ErrorType.NETWORK,severity:n.severity,message:"Error when fetching data from ".concat(e),errorInfo:__spreadArray([{key:"url",value:e}],__read(objectToKeyValueArray(r)),!1),extras:__spreadArray(__spreadArray(__spreadArray([],__read(n.extras||[]),!1),__read(t),!1),[{key:"triggeredEvents",value:"[".concat(triggeredEvents.toString(),"]")}],!1)})},remoteLogReactErrorBoundary=function(t,o,i){return void 0===i&&(i={}),__awaiter(void 0,void 0,void 0,function(){var r,n;return __generator(this,function(e){switch(e.label){case 0:return r=performLogRequest,n={errorType:ErrorType.APP,message:t.message},[4,getStackTrace(t)];case 1:return[2,r.apply(void 0,[__assign.apply(void 0,[(n.stackTrace=e.sent(),n.errorInfo=objectToKeyValueArray(o),n),i])])]}})})},remoteLogMessage=function(e,r){return performLogRequest(__assign({errorType:ErrorType.MESSAGE,message:e},r=void 0===r?{}:r))};exports.remoteLogAppError=remoteLogAppError,exports.remoteLogFetchError=remoteLogFetchError,exports.remoteLogMessage=remoteLogMessage,exports.remoteLogReactErrorBoundary=remoteLogReactErrorBoundary,exports.remoteLogWindowOnError=remoteLogWindowOnError;
